import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { ButtonController, IButtonControllerOptions } from '../../../../Common/ButtonController';
import { AnimationContents } from '../../../../../AnimationContents';
import { AppStateEnum, GameModel } from '../../../../Models/Game/GameModel';
import { GameLogic } from '../../../../Logic/GameLogic';

export class LeaderboardController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic) {
        super("LeaderboardController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.RATING_SCREEN_JSON,
            libraryName: "main",
            childControllers: {
                closeButton: {
                    instanceName: "window.container.btn_close",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.gotoAndPlay("window close");
                            this.$queue.get('hide').addToQueue();
                        }
                    }
                }
            },
            queue: {
                hide: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        if (this.$model.appState === AppStateEnum.game) {
                            this._gameLogic.showGameEnd();
                        } else {
                            this._gameLogic.resetMenu();
                        }
                    }
                }
            }
        };
    }

    protected onInitialize(): void {
        this.gotoAndPlay("window initialization")
        
        for(let i = 0; i < 8; i++) {
            this.setTextByQuery(`window.container.content.num${i}`,`${i + 1}`);
            this.setTextByQuery(`window.container.content.count${i}`,`${1000 + i}`);
            this.setTextByQuery(`window.container.content.player${i}`,`Player_${i}`);
        }
        this.setTextByQuery(`window.container.content.num`,`${88}`);
        this.setTextByQuery(`window.container.content.count`,`${this.$model.player.score}`);
        this.setTextByQuery(`window.container.content.player`,`${this.$model.player.name || "Player"} `);
    }

    protected onLandscape(): void {
        this.display.scale.set(1.1);
        this.display.y = 20;
    }
}

